import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.8582 4.95176L7.29255 3.4513C7.65251 3.29403 8.05457 3.29403 8.41454 3.4513L12.0663 5.04676C12.1178 5.06923 12.1752 5.06923 12.2266 5.04676L15.0198 3.82641C15.1981 3.7485 15.3886 3.70846 15.5808 3.70846C16.4106 3.70846 17.0833 4.4387 17.0833 5.3395V13.5633C17.0833 14.2328 16.7064 14.8343 16.1327 15.0803L12.6984 16.5527C12.3438 16.7047 11.9492 16.7047 11.5945 16.5527L7.93239 14.9826C7.88173 14.9609 7.82535 14.9609 7.77469 14.9826L4.97112 16.1846C4.79539 16.2599 4.60814 16.2986 4.4192 16.2986C3.58938 16.2986 2.91667 15.5683 2.91667 14.6675V6.46485C2.91667 5.79917 3.28933 5.2003 3.8582 4.95176ZM11.2604 6.20167L8.41667 4.95925V13.6871L11.25 14.9018V6.31668C11.25 6.27743 11.2536 6.239 11.2604 6.20167ZM12.5833 6.39118V15.0989L15.6597 13.78C15.7416 13.7448 15.7955 13.6589 15.7955 13.5633V5.3395C15.7955 5.21082 15.6994 5.10649 15.5808 5.10649C15.5534 5.10649 15.5261 5.11221 15.5007 5.12334L12.7075 6.34369C12.6666 6.36155 12.6252 6.37738 12.5833 6.39118ZM4.33905 6.24869L7.08334 5.04972V13.7759L4.49804 14.8843C4.47294 14.895 4.44619 14.9005 4.4192 14.9005C4.30065 14.9005 4.20455 14.7962 4.20455 14.6675V6.46485C4.20455 6.36975 4.25779 6.2842 4.33905 6.24869Z",
      fill: "#FF5537"
    }, null, -1)
  ]))]))
}
export default { render: render }